export const catsOf = (p) => (p?.categories?.length ? p.categories : [p?.category].filter(Boolean));
